/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

export const product = {
  productDetails: {
    id: 'Código',
    quantity: 'Quantidade',
    productDetails: 'Detalhes do produto',
    specification: 'Especificações',
    reviews: 'Comentários',
    shipping: 'Armador',
    share: 'Compartilhar',
    showComments: 'Mostrar comentários',
    noComments: 'Ainda não há comentários',
    showReviews: 'Comentários',
    noReviews: 'Ainda não há comentários',
    productPrice: 'Preço do produto',
    noProductImage: 'Nenhuma imagem disponível, {{ product }}',
  },
  productList: {
    filterBy: {
      label: 'Filtrar por',
      action: 'Filtrar por',
    },
    activeFilter:
      '{{{filter}}, clicar neste botão removerá o filtro',
    appliedFilter: 'Filtro aplicado:',
    showLess: 'Mostrar menos...',
    showMore: 'Mostrar mais...',
    sortBy: 'Classificar por',
    sortResults: 'Classificar resultados',
    backToTopBtn: 'VOLTAR AO TOPO',
    showMoreBtn: 'MOSTRAR MAIS',
    productSearchPagination: 'Paginação de pesquisa de produtos',
    productListResults: 'Lista de resultados do produto',
  },
  productFacetNavigation: {
    filterBy: {
      label: 'Filtrar por',
      action: 'Filtrar por',
      facet: 'Filtrar resultados por facetas',
      name: 'Filtrar por {{{name}}',
    },
    appliedFilter: 'Filtro aplicado:',
    showLess: 'Mostrar menos...',
    showMore: 'Mostrar mais...',
    sortBy: 'Classificar por',
    ariaLabelShowLess:
      'Mostrar menos... Clicar neste botão restringirá as opções para o grupo ativo',
    ariaLabelShowMore:
      'Mostrar mais... No entanto, clicar neste botão exibirá todas as opções para o grupo ativo',
    ariaLabelItemsAvailable: '{{{name}}, {{{state}} {{count}} Artigo disponível',
    ariaLabelItemsAvailable_other:
      '{{{name}}, {{{state}} {{count}} Itens disponíveis',
    decreaseOptionsVisibility:
      'As opções estavam ocultas do grupo ativo, pressione-o para trás para lê-las ou para frente para o próximo grupo',
    increaseOptionsVisibility:
      'Adicionadas mais opções ao grupo ativo, com a tecla Tab para trás para lê-las ou avançar para o próximo grupo',
  },
  productSummary: {
    id: 'Código',
    showRealimentação: 'Mostrar comentários',
    showRealimentaçãoDetailed:
      'Mostrar {{count}} comentários, Classificado {{{rating}} de 5 estrelas',
    share: 'Compartilhar',
    newItemPrice: 'Preço do novo item',
  },
  productReview: {
    overallRating: 'Classificação geral',
    overallClassification: 'Avaliação geral',
    reviewTitle: 'Título da revisão',
    writeYourComments: 'Escreva seus comentários',
    rating: 'Classificação',
    ratingRequired: 'Classificação del producto, requerida',
    addRate: 'Adicionar taxa: {{count}} estrela',
    addRate_other: 'Adicionar taxa: {{count}} estrelas',
    reviewerName: 'Nome do revisor (opcional)',
    writeReview: 'Escreva um comentário',
    more: 'Mostrar mais comentários',
    less: 'Mostrar menos comentários',
    thankYouForReview:
      'Obrigado pela revisão! Observe que as avaliações podem exigir revisão antes de aparecer aqui.',
    postReviewFail:
      'Algo deu errado ao postar sua avaliação. Por favor, tente novamente mais tarde.',
  },
  productCarousel: {
    carouselLabel: 'Carrossel, {{{title}}',
  },
  addToCart: {
    itemsAddedToYourCart: 'Item(ns) adicionado(s) ao seu carrinho',
    itemsIncrementedInYourCart:
      'Este item já estava no seu carrinho. A quantidade foi atualizada.',
    items: 'Artigos',
    updatingCart: 'Atualizando o carrinho...',
    addToCart: 'Adicionar ao carrinho',
    viewCart: 'Ver carrinho',
    proceedToCheckout: 'Proceder ao pagamento',
    quantity: 'Quantidade',
    quantityFull: 'Quantidade',
    checkQuantity: 'Consulte a disponibilidade',
    outOfStock: 'Sem stock',
    inStock: 'Em stock',
    selectStyleAndSize: 'Selecione o estilo e o tamanho para verificar o stock',
    removeFromCart: 'Retire o produto do carrinho',
    closeModal: 'Fechar modal',
    buyItAgain: 'Compre novamente',
    addToActiveCart: 'Adicionar ao carrinho activa',
    unitTable: {
      quantity: 'Unidad/Embalagem',
      unitType: 'Embalagem',
      unitWeight: "Peso",
      unitSize: "Medir"
    },
  },
  TabPanelContainer: {
    tabs: {
      ProductDetailsTabComponent: 'Detalhes do produto',
      ProductSpecsTabComponent: 'Especificações',
      ProductReviewsTabComponent: 'Comentários',
      deliveryTab: 'Armador',
      SparePartsTabComponent: ' Peças de Reabastecimento',
      TechnicalAndSafetyTabComponent: 'Documentação para download'
    },
    tabPanelContainerRegion: 'Grupo de guias com mais detalhes do produto',
  },
  addToWishList: {
    add: 'Adicionar à lista de desejos',
    remove: 'Remover da lista de desejos',
    anonymous: 'Inicie sessão para adicionar à lista de desejos',
    addedToWishList: 'Produto adicionado à lista de desejos',
    removedFromWishList: 'Produto removido da lista de desejos',
  },
  stockNotification: {
    notifyMe: 'NOTIFIQUE-ME',
    stopNotify: 'AVISO DE DETENÇÃO',
    getNotify: 'Receba uma notificação quando este produto estiver disponível.',
    getNotifySuffix: 'para ser notificado quando este produto estiver disponível.',
    activateChannelsPrefix: 'Para receber uma notificação, você precisa ativar o ',
    channelsLink: 'Canais de notificação',
    activateChannelsSuffix: '.',
    notified: 'Você será notificado quando este produto estiver de volta em stock.',
    getNotified: 'Receba uma notificação quando este produto estiver novamente em stock.',
    unsubscribeSuccess:
      'Você não receberá uma notificação de devolução para este produto.',
    subscriptionDialog: {
      header: 'Assinatura esgotada',
      notifiedPrefix: 'Você será notificado sobre:',
      notifiedSuffix: 'assim que este produto estiver novamente em stock.',
      manageChannelsPrefix:
        'Gerencie seus canais de notificação preferidos no ',
      manageChannelsLink: 'Preferência de notificação',
      manageChannelsSuffix: ' página.',
      manageSubscriptionsPrefix: 'Você pode gerenciar suas assinaturas em ',
      manageSubscriptionsLink: 'Meus interesses',
      manageSubscriptionsSuffix: ' página.',
      okBtn: 'Concordo',
      subscribing:
        'Subscrever notificações de rutura de stock para este produto',
    },
  },
  itemCounter: {
    removeOne: 'Remova um',
    addOneMore: 'Adicione mais um',
    quantity: 'Quantidade',
  },
  productView: {
    gridView: 'Selecione esta opção para alternar para a Visualização em Grade',
    listView: 'Selecione esta opção para alternar para o modo de exibição de lista',
  },
};
